import { render } from "./PickupItemsReport.vue?vue&type=template&id=0841f28c&scoped=true"
import script from "./PickupItemsReport.vue?vue&type=script&lang=js"
export * from "./PickupItemsReport.vue?vue&type=script&lang=js"

import "./PickupItemsReport.vue?vue&type=style&index=0&id=0841f28c&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0841f28c"]])

export default __exports__